<div fxLayout="column" fxLayoutAlign="end center" fxFlexFill>
  <div class="fxFlex image-button image-button-green">
    <div class="inner"><lacerta-rich-text-block [content]="title"></lacerta-rich-text-block></div>
  </div>
  <div class="fxFlex pointer pointer-green"></div>
</div>
<div class="patroon"></div>
